import request from "@/utils/request";
export const getHomeInfo = () => {
    return request.get("/home/info");
};
export const updateHomeInfo = (data) => {
    return request.put("/home/info", data);
};
